import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { EtiquetasTable } from "../../Components/etiquetas/list";

export function Etiquetas() {
  const navigate = useNavigate();
  const session = useSelector((store) => store.auth);

  useEffect(() => {
    if (!session) navigate("/");
  }, [session]);

  return (
    <Container>
      <EtiquetasTable />
    </Container>
  );
}

export const Container = styled.div`
  padding: 0 0 0 var(--navbar-size);
  min-height: 100vh;
`;
